import {
    INSTAGRAM,
    FACEBOOK,
    LINKEDIN,
    PINTEREST,
    TWITTER,
    TIKTOK_BUSINESS,
    YOUTUBE
} from '@/lib/socialProfile';
import { MediaViewerStatsInstagram } from '@/lib/analytics/mediaViewer/instagram';
import { MediaViewerStatsTwitter } from '@/lib/analytics/mediaViewer/twitter';
import { MediaViewerStatsFacebook } from '@/lib/analytics/mediaViewer/facebook';
import { MediaViewerStatsPinterest } from '@/lib/analytics/mediaViewer/pinterest';
import { MediaViewerStatsLinkedin } from '@/lib/analytics/mediaViewer/linkedin';
import { MediaViewerStatsTiktokBusiness } from '@/lib/analytics/mediaViewer/tiktokBusiness';
import { MediaViewerStatsYoutube } from '@/lib/analytics/mediaViewer/youtube';

export const MediaViewerStatsConfig = (type) => {
    let config;
    switch (type) {
        case INSTAGRAM:
            config = MediaViewerStatsInstagram;
            break;
        case FACEBOOK:
            config = MediaViewerStatsFacebook;
            break;
        case LINKEDIN:
            config = MediaViewerStatsLinkedin;
            break;
        case PINTEREST:
            config = MediaViewerStatsPinterest;
            break;
        case TWITTER:
            config = MediaViewerStatsTwitter;
            break;
        case TIKTOK_BUSINESS:
            config = MediaViewerStatsTiktokBusiness;
            break;
        case YOUTUBE:
            config = MediaViewerStatsYoutube;
            break;
        default:
            throw new Error();
    }
    return config;
};
